import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../UserContext';
import { useLocation } from 'react-router-dom';
import { registerUser, loginUser } from '../services/apiService';
import '../styles/RegisterLogin.css';
import { FiSun, FiMoon, FiArrowDown, FiArrowRightCircle } from 'react-icons/fi';
import Footer from '../components/Footer';
import Select from 'react-select';
import en from '../assets/en.png';
import af from '../assets/af.png';
import am from '../assets/am.png';
import ar from '../assets/ar.png';
import bg from '../assets/bg.png';
import bn from '../assets/bn.png';
import ca from '../assets/ca.png';
import cs from '../assets/cs.png';
import cy from '../assets/cy.png';
import da from '../assets/da.png';
import de from '../assets/de.png';
import el from '../assets/el.png';
import es from '../assets/es.png';
import eu from '../assets/eu.png';
import fa from '../assets/fa.png';
import fr from '../assets/fr.png';
import gl from '../assets/gl.png';
import he from '../assets/he.png';
import hi from '../assets/hi.png';
import hu from '../assets/hu.png';
import id from '../assets/id.png';
import it from '../assets/it.png';
import ja from '../assets/ja.png';
import ko from '../assets/ko.png';
import ku from '../assets/ku.png';
import my from '../assets/my.png';
import nl from '../assets/nl.png';
import no from '../assets/no.png';
import pl from '../assets/pl.png';
import pt from '../assets/pt.png';
import ro from '../assets/ro.png';
import ru from '../assets/ru.png';
import sq from '../assets/sq.png';
import sr from '../assets/sr.png';
import sv from '../assets/sv.png';
import sw from '../assets/sw.png';
import th from '../assets/th.png';
import tl from '../assets/tl.png';
import tr from '../assets/tr.png';
import uk from '../assets/uk.png';
import ur from '../assets/ur.png';
import vi from '../assets/vi.png';
import zh from '../assets/zh.png';
import AddressAutocomplete from '../components/AddressAutocomplete';
import { countryDialingInfo } from '../components/PhonePrefixes';

const customSingleValue = ({ data }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <img src={data.icon} alt={data.label} style={{ width: 20, marginRight: 8, color: '#333' }} />
    {data.label}
  </div>
);

const customOption = (props) => {
  const { data, innerRef, innerProps } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: 10, color: '#333' }}>
      <img src={data.icon} alt={data.label} style={{ width: 20, marginRight: 10, color: '#333' }} />
      {data.label}
    </div>
  );
};

function RegisterLogin() {
  const { t, i18n } = useTranslation();
  const { setUser } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  
  const scrollToBottom = () => {
    const footer = document.getElementById('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const [isLogin, setIsLogin] = useState(true);

  const [formData, setFormData] = useState({
    role: 'patient',     
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phoneNumber: '',  
    address: '',
    sex: '',            
    dateOfBirth: '',
    speciality: '',        
    yearsSinceLicensed: '',
    latitude: '',
    longitude: ''   
  });

  const [fullPhoneNumber, setFullPhoneNumber] = useState('');

  const [error, setError] = useState('');

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  const languageOptions = [
    { value: 'en', label: 'English', icon: en },
    { value: 'af', label: 'Afrikaans', icon: af },
    { value: 'am', label: 'Amharic - አማርኛ', icon: am },
    { value: 'ar', label: 'Arabic - اَلْعَرَبِيَّةُ', icon: ar },
    { value: 'bg', label: 'Bulgarian - Български', icon: bg },
    { value: 'bn', label: 'Bengali/Bangla - বাংলা', icon: bn },
    { value: 'ca', label: 'Catalan - Català', icon: ca },
    { value: 'cs', label: 'Czech - Čeština', icon: cs },
    { value: 'cy', label: 'Welsh - Cymraeg', icon: cy },
    { value: 'da', label: 'Danish - Dansk', icon: da },
    { value: 'de', label: 'German - Deutsch', icon: de },
    { value: 'el', label: 'Greek - Ελληνικά', icon: el },
    { value: 'es', label: 'Spanish - Español/Castellano', icon: es },
    { value: 'eu', label: 'Basque - Euskara', icon: eu },
    { value: 'fa', label: 'Persian/Farsi - فارسی', icon: fa },
    { value: 'fr', label: 'French - Français', icon: fr },
    { value: 'gl', label: 'Galician - Galego', icon: gl },
    { value: 'he', label: 'Hebrew - עברית', icon: he },
    { value: 'hi', label: 'Hindi - हिन्दी', icon: hi },
    { value: 'hu', label: 'Hungarian - Magyar', icon: hu },
    { value: 'id', label: 'Indonesian - Bahasa Indonesia', icon: id },
    { value: 'it', label: 'Italian - Italiano', icon: it },
    { value: 'ja', label: 'Japanese - 日本語', icon: ja },
    { value: 'ko', label: 'Korean - 한국어', icon: ko },
    { value: 'ku', label: 'Kurdish - Kurdî', icon: ku },
    { value: 'my', label: 'Burmese - မြန်မာဘာသာ', icon: my },
    { value: 'nl', label: 'Dutch - Nederlands', icon: nl },
    { value: 'no', label: 'Norwegian - Norsk', icon: no },
    { value: 'pl', label: 'Polish - Polski', icon: pl },
    { value: 'pt', label: 'Portuguese - Português', icon: pt },
    { value: 'ro', label: 'Romanian - Română', icon: ro },
    { value: 'ru', label: 'Russian - русский язык', icon: ru },
    { value: 'sq', label: 'Albanian - Shqip', icon: sq },
    { value: 'sr', label: 'Serbian - Српски / srpski', icon: sr },
    { value: 'sv', label: 'Swedish - Svenska', icon: sv },
    { value: 'sw', label: 'Swahili - Kiswahili', icon: sw },
    { value: 'th', label: 'Thai - ไทย', icon: th },
    { value: 'tl', label: 'Tagalog', icon: tl },
    { value: 'tr', label: 'Turkish - Türkçe', icon: tr },
    { value: 'uk', label: 'Ukrainian - Українська', icon: uk },
    { value: 'ur', label: 'Urdu - اُردُو', icon: ur },
    { value: 'vi', label: 'Vietnamese - Tiếng Việt', icon: vi },
    { value: 'zh', label: 'Standard Chinese - 现代标准汉语', icon: zh }
  ];  

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, [language, i18n]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      if (name === 'phoneNumber' || name === 'countryCode') {
        const country = countryDialingInfo[updated.countryCode];
        const prefix = country ? country.prefix : '';
        const raw = updated.phoneNumber.replace(/\D/g, '');
        updated.fullPhoneNumber = prefix + raw;
        setFullPhoneNumber(updated.fullPhoneNumber);
      }
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (isLogin) {
      try {
        const loggedInUser = await loginUser({
          email: formData.email,
          password: formData.password,
        });
        setUser(loggedInUser);
        localStorage.setItem('userProfile', JSON.stringify(loggedInUser));
        navigate('/');
      } catch (err) {
        setError(t('invalidCredentials'));
      }
    } else {
      const isValid =
        formData.firstName &&
        formData.lastName &&
        formData.email &&
        formData.password &&
        formData.phoneNumber &&
        formData.address &&
        formData.sex &&
        formData.dateOfBirth &&
        (formData.role === 'patient' ||
          (formData.role === 'physio' && formData.speciality && formData.yearsSinceLicensed && formData.companyName));

      if (!isValid) {
        setError(t('fillAllFields'));
        return;
      }

      try {
        const newUser = await registerUser(formData);
        setUser(newUser);
        localStorage.setItem('userProfile', JSON.stringify(newUser));
        navigate('/'); 
      } catch (err) {
        const message = err?.error || err?.message || "Registration failed.";
        setError(typeof message === 'string' ? message : JSON.stringify(message));
      }
    }
  };

  return (
    <>
    <div className="bar">
          <img src="/logo1024.png" alt="PE Logo" className="bar-left" />
        <div className="bar-center">
          <img src="/PE.png" alt="PE Title" />
        </div>
        <div className="bar-right">
          <button className="scroll-button" onClick={scrollToBottom}><FiArrowDown /> {t('scrollDown')}</button>
        </div>
    </div>
    <div className="register-login-container">
      <h2>{isLogin ? t('login') : t('register')}</h2>
      {error && <p className="error">{error}</p>}
      <div className="toggle-controls">
        <Select
          value={languageOptions.find(opt => opt.value === language)}
          onChange={(selectedOption) => setLanguage(selectedOption.value)}
          options={languageOptions}
          components={{ SingleValue: customSingleValue, Option: customOption }}
          isSearchable={true}
          styles={{
            control: (base) => ({
              ...base,
              fontFamily: 'Figtree',
              width: '300px',
              marginTop: '10px',
              color: '#333',
              backgroundColor: '#ffffffcc'
            }),
          }}
        />
        <button
          className="dark-toggle-button"
          onClick={() => setDarkMode(!darkMode)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          title={t('darkLight')}
        >
          {isHovered ? (darkMode ? <FiSun /> : <FiMoon />) : (darkMode ? <FiMoon /> : <FiSun />)}
        </button>
      </div>
      
      <form onSubmit={handleSubmit}>
        

        {!isLogin && (
          <>
            <div className="form-group">
              <label>{t('selectRole')}:</label>
              <select name="role" style={{ fontFamily: 'Figtree', textAlign: 'center' }} value={formData.role} onChange={handleChange}>
                <option value="patient">{t('patient')}</option>
                <option value="physio">{t('physio')}</option>
              </select>
            </div>
            <div className="form-group">
              <label>{t('firstname')}:</label>
              <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>{t('lastname')}:</label>
              <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>{t('sex')}</label>
              <select name="sex" style={{ fontFamily: 'Figtree', textAlign: 'center' }} value={formData.sex} onChange={handleChange} required>
                <option value="">{t('selectSex')}</option>
                <option value="male">{t('male')}</option>
                <option value="female">{t('female')}</option>
              </select>
            </div>
            <div className="form-group">
              <label>{t('dob')}</label>
              <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} min="1900-01-01" max="2025-04-10" required />
            </div>
            <div className="form-group">
              <label>{t('country')}</label>
              <select 
                style={{ fontFamily: 'Figtree', textAlign: 'center' }}
                name="countryCode"
                value={formData.countryCode || ''}
                onChange={(e) => setFormData(prev => ({ ...prev, countryCode: e.target.value }))}
              >
                <option value="">-- {t('selectCountry')} --</option>
                <option value="gb">United Kingdom</option>
                <option value="ad">Andorra</option>
                <option value="ae">United Arab Emirates</option>
                <option value="af">Afghanistan</option>
                <option value="ag">Antigua and Barbuda</option>
                <option value="ai">Anguilla</option>
                <option value="al">Albania</option>
                <option value="am">Armenia</option>
                <option value="ao">Angola</option>
                <option value="aq">Antarctica</option>
                <option value="ar">Argentina</option>
                <option value="as">American Samoa</option>
                <option value="at">Austria</option>
                <option value="au">Australia</option>
                <option value="aw">Aruba</option>
                <option value="ax">Aland Islands</option>
                <option value="az">Azerbaijan</option>
                <option value="ba">Bosnia and Herzegovina</option>
                <option value="bb">Barbados</option>
                <option value="bd">Bangladesh</option>
                <option value="be">Belgium</option>
                <option value="bf">Burkina Faso</option>
                <option value="bg">Bulgaria</option>
                <option value="bh">Bahrain</option>
                <option value="bi">Burundi</option>
                <option value="bj">Benin</option>
                <option value="bl">Saint-Barthélemy</option>
                <option value="bm">Bermuda</option>
                <option value="bn">Brunei Darussalam</option>
                <option value="bo">Bolivia</option>
                <option value="bq">Caribbean Netherlands</option>
                <option value="br">Brazil</option>
                <option value="bs">Bahamas</option>
                <option value="bt">Bhutan</option>
                <option value="bv">Bouvet Island</option>
                <option value="bw">Botswana</option>
                <option value="by">Belarus</option>
                <option value="bz">Belize</option>
                <option value="ca">Canada</option>
                <option value="cc">Cocos (Keeling) Islands</option>
                <option value="cd">Democratic Republic of the Congo</option>
                <option value="cf">Central African Republic</option>
                <option value="cg">Republic of the Congo</option>
                <option value="ch">Switzerland</option>
                <option value="ci">Côte d'Ivoire (Ivory Coast) </option>
                <option value="ck">Cook Islands</option>
                <option value="cl">Chile</option>
                <option value="cm">Cameroon</option>
                <option value="cn">China</option>
                <option value="co">Colombia</option>
                <option value="cr">Costa Rica</option>
                <option value="cu">Cuba</option>
                <option value="cv">Cabo Verde</option>
                <option value="cw">Curaçao</option>
                <option value="cx">Christmas Island</option>
                <option value="cy">Cyprus</option>
                <option value="cz">Czech Republic</option>
                <option value="de">Germany</option>
                <option value="dj">Djibouti</option>
                <option value="dk">Denmark</option>
                <option value="dm">Dominica</option>
                <option value="do">Dominican Republic</option>
                <option value="dz">Algeria</option>
                <option value="ec">Ecuador</option>
                <option value="ee">Estonia</option>
                <option value="eg">Egypt</option>
                <option value="eh">Western Sahara</option>
                <option value="er">Eritrea</option>
                <option value="es">Spain</option>
                <option value="et">Ethiopia</option>
                <option value="fi">Finland</option>
                <option value="fj">Fiji</option>
                <option value="fk">Falkland Islands</option>
                <option value="fm">Micronesia (Federated States of) </option>
                <option value="fo">Faroe Islands</option>
                <option value="fr">France</option>
                <option value="ga">Gabon</option>
                <option value="gd">Grenada</option>
                <option value="ge">Georgia</option>
                <option value="gf">French Guiana</option>
                <option value="gg">Guernsey</option>
                <option value="gh">Ghana</option>
                <option value="gi">Gibraltar</option>
                <option value="gl">Greenland</option>
                <option value="gm">The Gambia</option>
                <option value="gn">Guinea</option>
                <option value="gp">Guadeloupe</option>
                <option value="gq">Equatorial Guinea</option>
                <option value="gr">Greece</option>
                <option value="gs">South Georgia and the South Sandwich Islands</option>
                <option value="gt">Guatemala</option>
                <option value="gu">Guam</option>
                <option value="gw">Guinea Bissau</option>
                <option value="gy">Guyana</option>
                <option value="hk">Hong Kong (SAR of China)</option>
                <option value="hm">Heard Island and McDonald Islands</option>
                <option value="hn">Honduras</option>
                <option value="hr">Croatia</option>
                <option value="ht">Haiti</option>
                <option value="hu">Hungary</option>
                <option value="id">Indonesia</option>
                <option value="ie">Ireland</option>
                <option value="il">Israel</option>
                <option value="im">Isle of Man</option>
                <option value="in">India</option>
                <option value="io">British Indian Ocean Territory</option>
                <option value="iq">Iraq</option>
                <option value="ir">Iran</option>
                <option value="is">Iceland</option>
                <option value="it">Italy</option>
                <option value="je">Jersey</option>
                <option value="jm">Jamaica</option>
                <option value="jo">Jordan</option>
                <option value="jp">Japan</option>
                <option value="ke">Kenya</option>
                <option value="kg">Kyrgyzstan</option>
                <option value="kh">Cambodia</option>
                <option value="ki">Kiribati</option>
                <option value="km">Comoros</option>
                <option value="kn">Saint Kitts and Nevis</option>
                <option value="kp">North Korea</option>
                <option value="kr">South Korea</option>
                <option value="kw">Kuwait</option>
                <option value="ky">Cayman Islands</option>
                <option value="kz">Kazakhstan</option>
                <option value="la">Laos</option>
                <option value="lb">Lebanon</option>
                <option value="lc">Saint Lucia</option>
                <option value="li">Liechtenstein</option>
                <option value="lk">Sri Lanka</option>
                <option value="lr">Liberia</option>
                <option value="ls">Lesotho</option>
                <option value="lt">Lithuania</option>
                <option value="lu">Luxembourg</option>
                <option value="lv">Latvia</option>
                <option value="ly">Libya</option>
                <option value="ma">Morocco</option>
                <option value="mc">Monaco</option>
                <option value="md">Moldova</option>
                <option value="me">Montenegro</option>
                <option value="mf">Saint Martin (French part) </option>
                <option value="mg">Madagascar</option>
                <option value="mh">Marshall Islands</option>
                <option value="mk">North Macedonia</option>
                <option value="ml">Mali</option>
                <option value="mm">Myanmar</option>
                <option value="mn">Mongolia</option>
                <option value="mo">Macao (SAR of China)</option>
                <option value="mp">Northern Mariana Islands</option>
                <option value="mq">Martinique</option>
                <option value="mr">Mauritania</option>
                <option value="ms">Montserrat</option>
                <option value="mt">Malta</option>
                <option value="mu">Mauritius</option>
                <option value="mv">Maldives</option>
                <option value="mw">Malawi</option>
                <option value="mx">Mexico</option>
                <option value="my">Malaysia</option>
                <option value="mz">Mozambique</option>
                <option value="na">Namibia</option>
                <option value="nc">New Caledonia</option>
                <option value="ne">Niger</option>
                <option value="nf">Norfolk Island</option>
                <option value="ng">Nigeria</option>
                <option value="ni">Nicaragua</option>
                <option value="nl">Netherlands</option>
                <option value="no">Norway</option>
                <option value="np">Nepal</option>
                <option value="nr">Nauru</option>
                <option value="nu">Niue</option>
                <option value="nz">New Zealand</option>
                <option value="om">Oman</option>
                <option value="pa">Panama</option>
                <option value="pe">Peru</option>
                <option value="pf">French Polynesia</option>
                <option value="pg">Papua New Guinea</option>
                <option value="ph">Philippines</option>
                <option value="pk">Pakistan</option>
                <option value="pl">Poland</option>
                <option value="pm">Saint Pierre and Miquelon</option>
                <option value="pn">Pitcairn</option>
                <option value="pr">Puerto Rico</option>
                <option value="ps">Palestinian Territory</option>
                <option value="pt">Portugal</option>
                <option value="pw">Palau</option>
                <option value="py">Paraguay</option>
                <option value="qa">Qatar</option>
                <option value="re">Reunion</option>
                <option value="ro">Romania</option>
                <option value="rs">Serbia</option>
                <option value="ru">Russia</option>
                <option value="rw">Rwanda</option>
                <option value="sa">Saudi Arabia</option>
                <option value="sb">Solomon Islands</option>
                <option value="sc">Seychelles</option>
                <option value="sd">Sudan</option>
                <option value="se">Sweden</option>
                <option value="sg">Singapore</option>
                <option value="sh">Saint Helena</option>
                <option value="si">Slovenia</option>
                <option value="sj">Svalbard and Jan Mayen</option>
                <option value="sk">Slovakia</option>
                <option value="sl">Sierra Leone</option>
                <option value="sm">San Marino</option>
                <option value="sn">Sénégal</option>
                <option value="so">Somalia</option>
                <option value="sr">Suriname</option>
                <option value="st">São Tomé and Príncipe</option>
                <option value="ss">South Sudan</option>
                <option value="sv">El Salvador</option>
                <option value="sx">Saint Martin (Dutch part)</option>
                <option value="sy">Syria</option>
                <option value="sz">eSwatini</option>
                <option value="tc">Turks and Caicos Islands</option>
                <option value="td">Chad</option>
                <option value="tf">French Southern and Antarctic Lands</option>
                <option value="tg">Togo</option>
                <option value="th">Thailand</option>
                <option value="tj">Tajikistan</option>
                <option value="tk">Tokelau</option>
                <option value="tl">Timor-Leste</option>
                <option value="tm">Turkmenistan</option>
                <option value="tn">Tunisia</option>
                <option value="to">Tonga</option>
                <option value="tr">Türkiye</option>
                <option value="tt">Trinidad and Tobago</option>
                <option value="tv">Tuvalu</option>
                <option value="tw">Taiwan</option>
                <option value="tz">Tanzania</option>
                <option value="ua">Ukraine</option>
                <option value="ug">Uganda</option>
                <option value="um">United States Minor Outlying Islands</option>
                <option value="us">United States of America</option>
                <option value="uy">Uruguay</option>
                <option value="uz">Uzbekistan</option>
                <option value="va">City of the Vatican</option>
                <option value="vc">Saint Vincent and the Grenadines</option>
                <option value="ve">Venezuela</option>
                <option value="vg">British Virgin Islands</option>
                <option value="vi">United States Virgin Islands</option>
                <option value="vn">Vietnam</option>
                <option value="vu">Vanuatu</option>
                <option value="wf">Wallis and Futuna</option>
                <option value="ws">Samoa</option>
                <option value="xk">Kosovo</option>
                <option value="ye">Yemen</option>
                <option value="yt">Mayotte</option>
                <option value="za">South Africa</option>
                <option value="zm">Zambia</option>
                <option value="zw">Zimbabwe</option>
              </select>
            </div>
            <div className="form-group">
              <label>{t('phone')}:</label>
              <input type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={(e) => {
                  const cleaned = e.target.value.replace(/[^\d()]/g, '');
                  setFormData(prev => ({
                    ...prev,
                    phoneNumber: cleaned,
                    fullPhoneNumber: countryDialingInfo[prev.countryCode]?.prefix + cleaned || cleaned
                  }));
                  setFullPhoneNumber(countryDialingInfo[formData.countryCode]?.prefix + cleaned || cleaned);
                }}
                maxLength={20}
                minLength={3}
                required
                disabled={!formData.countryCode}
                placeholder={formData.countryCode ? t('enterPhone') : t('selectCountryFirst')}
              />
            </div>
              {fullPhoneNumber && (
                <div className="form-group">
                  <p><strong>{t('formattedPhone')}:</strong> {fullPhoneNumber}</p>
                </div>
              )}
            <div className="form-group">
              <label>{t('Address')}</label>
            {formData.countryCode ? (
              <AddressAutocomplete
                onSelect={(place) => {
                  setFormData(prev => ({
                    ...prev,
                    address: place.display_name,
                    latitude: place.lat,
                    longitude: place.lon
                  }));
                }}
                countryCode={formData.countryCode}
              />
            ) : (
              <input
                type="text"
                disabled
                placeholder={t('selectCountryFirst')}
                style={{
                  width: '100%',
                  padding: '10px',
                  fontSize: '1rem',
                  border: '1px solid #0000FF',
                  borderRadius: '4px',
                  textAlign: 'center',
                  fontFamily: 'Figtree'
                }}
              />
            )}
            </div>
            {formData.address && (
              <div className="form-group">
                <p><strong>{t('selectedAddress')}:</strong> {formData.address}</p>
              </div>
            )}
            
        {formData.role === 'patient' && (
          <>
          <div className="form-group">
          <label>{t('height')}</label>
          <input
            type="number"
            name="height"
            value={formData.height}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>{t('weight')}</label>
          <input
            type="number"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
            required
            />
            </div>
          </>
        )}
            {formData.role === 'physio' && (
              <>
                <div className="form-group">
              <label>{t('speciality')}</label>
                <select name="speciality" style={{ fontFamily: 'Figtree', textAlign: 'center' }} value={formData.speciality} onChange={handleChange} required>
                  <option value="">{t('enterSpeciality')}</option>
                    <option value="neurologicalDisorder">{t('neurologicalDisorder')}</option>
                    <option value="geriatrics">{t('geriatrics')}</option>
                    <option value="cardiovascularPulmonaryPhysiotherapy">{t('cardiovascularPulmonaryPhysiotherapy')}</option>
                    <option value="pediatricPhysiotherapy">{t('pediatricPhysiotherapy')}</option>
                    <option value="musculoskeletalPhysiotherapy">{t('musculoskeletalPhysiotherapy')}</option>
                    <option value="sportsPhysiotherapy">{t('sportsPhysiotherapy')}</option>
                    <option value="cardiovascularDisease">{t('cardiovascularDisease')}</option>
                    <option value="orthopedics">{t('orthopedics')}</option>
                    <option value="vestibularRehabilitation">{t('vestibularRehabilitation')}</option>
                    <option value="homecarePhysiotherapy">{t('homecarePhysiotherapy')}</option>
                    <option value="pediatrics">{t('pediatrics')}</option>
                    <option value="pelvicFloor">{t('pelvicFloor')}</option>
                    <option value="womensHealthPhysiotherapy">{t('womensHealthPhysiotherapy')}</option>
                    <option value="acupuncture">{t('acupuncture')}</option>
                    <option value="magneticTherapy">{t('magneticTherapy')}</option>
                    <option value="manualTherapy">{t('manualTherapy')}</option>
                    <option value="oncology">{t('oncology')}</option>
                    <option value="postOperativePhysiotherapist">{t('postOperativePhysiotherapist')}</option>
                    <option value="rehabilitation">{t('rehabilitation')}</option>
                    <option value="chestPhysiotherapy">{t('chestPhysiotherapy')}</option>
                    <option value="womensHealth">{t('womensHealth')}</option>
                  </select>
                </div>
            <div className="form-group">
              <label>{t('yearsSinceLicensed')}</label>
              <input
                type="number"
                name="yearsSinceLicensed"
                value={formData.yearsSinceLicensed}
                onChange={handleChange}
                placeholder={t('enterYearOfLicense')}
                required
                min="1982"
                max="2024"
              />
            </div>
            <div className="form-group">
              <label>{t('companyName')}</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder={t('enterCompanyName')}
              />
            </div>
              </>
            )}
          </>
        )}

        <div className="form-group">
          <label>{t('emaiL')}:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>{t('password')}</label>
          <input type="password" name="password" style={{ color: 'red' }} value={formData.password} onChange={handleChange} required />
        </div>

        <button type="submit">{isLogin ? t('login') : t('register')} <FiArrowRightCircle /></button>
      </form>

      <p>
        {isLogin ? t('dontHaveAccount') : t('alreadyHaveAccount')}
        <br/>
        <button className="link-button" onClick={() => { setIsLogin(!isLogin); setError(''); }}>
          {isLogin ? t('registerHere') : t('loginHere')}
        </button>
      </p>
      <nav className="f-links">
        <Link to="/faqs1">{t('patientFAQs')}</Link>
          <span>|</span>
        <Link to="/faqs2">{t('physioFAQs')}</Link>
      </nav>
    </div>
    <Footer path={location.pathname} />
    </>
  );
}

export default RegisterLogin;